<template>
  <div>
      erro
  </div>
</template>

<script>
    export default {
    	name: 'pagenotefound',
    };
</script>



// WEBPACK FOOTER //
// _source/javascripts/components/pageNotFind.vue